import React from 'react';

const OrdersTab = ({ orders }) => {
  return (
    <div className="bg-[#121212] border border-white/5 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-black/30">
            <tr>
              <th className="text-left px-4 py-3 text-xs font-mono uppercase text-zinc-500">Order ID</th>
              <th className="text-left px-4 py-3 text-xs font-mono uppercase text-zinc-500">User</th>
              <th className="text-left px-4 py-3 text-xs font-mono uppercase text-zinc-500">Items</th>
              <th className="text-left px-4 py-3 text-xs font-mono uppercase text-zinc-500">Total</th>
              <th className="text-left px-4 py-3 text-xs font-mono uppercase text-zinc-500">Status</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => (
              <tr key={order.order_id} className="border-t border-white/5">
                <td className="px-4 py-3 text-zinc-400 font-mono text-sm">{order.order_id}</td>
                <td className="px-4 py-3 text-white">{order.user_id}</td>
                <td className="px-4 py-3 text-zinc-400">{order.items?.length || 0} items</td>
                <td className="px-4 py-3 text-[#D4AF37] font-mono">${order.total?.toFixed(2)}</td>
                <td className="px-4 py-3">
                  <span className="text-xs px-2 py-1 bg-green-500/20 text-green-500 capitalize">
                    {order.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OrdersTab;
